/**
 * This is used to render accordions created via shortcode in Wordpress
 * https://github.com/bankrate/bankrate-cms/blob/master/src/Plugins/BankrateCustomShortcodes/Shortcodes/AccordionItem.php
 */
function loadAccordions() {
  var accordionBreadcrumbs = document.querySelectorAll(
    '.wp-accordion-breadcrumb'
  )
  var accordionItems = document.querySelectorAll('.wp-accordion'),
    i,
    j

  for (i = 0; i < accordionItems.length; i++) {
    accordionItems[i].addEventListener('click', function() {
      if (this.classList.contains('--expanded')) {
        this.classList.remove('--expanded')
        this.querySelector('span').classList.remove('--expanded')
        this.nextElementSibling.style.display = 'none'
      } else {
        for (j = 0; j < accordionItems.length; j++) {
          accordionItems[j].classList.remove('--expanded')
          accordionItems[j].querySelector('span').classList.remove('--expanded')
          accordionItems[j].nextElementSibling.style.display = 'none'
        }

        this.classList.add('--expanded')
        this.querySelector('span').classList.add('--expanded')
        this.nextElementSibling.style.display = 'block'
      }
    })
  }

  if (accordionBreadcrumbs) {
    // Event Listener to toggle accordions when breadcrumb is clicked
    accordionBreadcrumbs.forEach(link => {
      link.addEventListener('click', function() {
        const id = link.getAttribute('href').replace('#', '')
        const openAccordion = document.getElementById(id)

        // Add "active classes" to open accordion
        if (openAccordion) {
          openAccordion.classList.add('--expanded')
          openAccordion.querySelector('span').classList.add('--expanded')
          openAccordion.nextElementSibling.style.display = 'block'
        }
      })
    })
  }
}

setTimeout(loadAccordions, 1000)
